<script setup lang="ts">
import { onMounted } from "vue";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useRoute } from "vue-router";
import { fetchConfirmEmail } from "@/api/user";

onMounted(async () => {
  const queryToken = route.query.token as string | null;
  const queryEmail = route.query.email as string | null;
  if (queryToken !== null && queryEmail !== null) {
    try {
      await fetchConfirmEmail(queryEmail, queryToken);
    } catch (error) {
      console.log(error);
    }
  }
  await router.replace({ name: ROUTE_NAMES.HOME });
});

const route = useRoute();
</script>

<template>
  <div
    class="bg-black bg-opacity-50 h-screen w-screen flex items-center justify-center"
  >
    <div
      class="align-[-0.125em] animate-spin border-4 border-current border-e-transparent border-solid h-8 w-8 rounded-full text-white"
      role="status"
    ></div>
  </div>
</template>
